import {Component, ViewChild} from '@angular/core';

import {BoiteDialogueLogComponent} from '../../../../../../val-ammon-composants/val-traitements-lib/src/public-api';
import {AeFCommandeFacture, AeFRapprocherCommandesFacturesAchatParametres, AeFRapprocherCommandesFacturesAchatResultat, EFactTraitementService} from '../../../../../../val-ammon-services/val-services-efact-lib/src/public-api';
import {ValApiResultat} from '../../../../../../val-ammon-services/val-services-communs-lib/src/public-api';

//Traitement de rapprochement de commande
@Component (
{
  selector: 'val-rapprocher-commande-factures-achat',
  imports: 
  [
    BoiteDialogueLogComponent
  ],
  templateUrl: './rapprocher-commande-factures-achat.component.html',
  styleUrl: './rapprocher-commande-factures-achat.component.scss',
})
export class RapprocherCommandeFacturesAchatComponent 
{
  //Création
  //  Paramètres
  //    eFactTraitementService: Service e-Facture
  constructor (private eFactTraitementService: EFactTraitementService) 
  {
  }
  
  //Boîte de dialogue log
  @ViewChild ("boiteDialogueLog")
  public boiteDialogueLog!: BoiteDialogueLogComponent;

  //Exécute le traitement
  //  Paramètres
  //    identifiantsFactures : Identifiants des factures
  public async Executer (identifiantsFactures: string[]) : Promise<AeFCommandeFacture[]> 
  {
    let operation: Promise<AeFCommandeFacture[]>;
    let aefRapprocherCommandesFacturesAchatParametres: AeFRapprocherCommandesFacturesAchatParametres;
    let valApiResultat: ValApiResultat<AeFRapprocherCommandesFacturesAchatResultat>;
    let commandesFactures: AeFCommandeFacture[];

    operation = new Promise<AeFCommandeFacture[]> (async (fonctionRetour) =>
    {
      commandesFactures = [];
      try
      {
        aefRapprocherCommandesFacturesAchatParametres = new AeFRapprocherCommandesFacturesAchatParametres ();
        aefRapprocherCommandesFacturesAchatParametres.identifiantSession = crypto.randomUUID ();
        aefRapprocherCommandesFacturesAchatParametres.identifiantsFactures = identifiantsFactures;

        this.boiteDialogueLog.Executer (aefRapprocherCommandesFacturesAchatParametres.identifiantSession);

        valApiResultat = await this.eFactTraitementService.RapprocherCommandesFacturesAchat (aefRapprocherCommandesFacturesAchatParametres);

        await this.boiteDialogueLog.AttendreFermeture ();

        if (valApiResultat.status === "success")
          commandesFactures = valApiResultat.resultat!.commandesFactures;
      }
      catch (erreur)
      {
      }

      fonctionRetour (commandesFactures);
    });

    return operation;
  }
}
